import { useCallback } from 'react';
import tw from 'twin.macro';
import { atom, useAtom } from 'jotai';
import { useTranslation } from 'next-i18next';

import { BaseModal, ButtonV2, Title } from '@restworld/ui-ds';
import { useIsEmployerAnAdmin } from '@restworld/feature-authentication';

export const isEmployerNoPermissionToBuySlotModalOpenAtom = atom(false);

function EmployerNoPermissionToBuySlotModal() {
  const { t } = useTranslation('product-description-page');
  const [isOpen, setIsOpen] = useAtom(isEmployerNoPermissionToBuySlotModalOpenAtom);
  const isAdmin = useIsEmployerAnAdmin();

  const handleClose = useCallback(() => setIsOpen(false), [setIsOpen]);

  return (
    <BaseModal
      open={isOpen}
      onClose={handleClose}
      footer={
        <div tw="w-full flex items-center justify-center">
          <ButtonV2 onClick={handleClose}>{t('close')}</ButtonV2>
        </div>
      }
    >
      <div tw="max-w-[560px] mx-auto text-center">
        <Title fontWeight="semibold" textColor="neutral-700" twStyle={tw`text-lg! my-5`}>
          {t(
            isAdmin
              ? 'as_a_base_level_collaborator_you_dont_have_the_permission_required_to_purchase_slots'
              : 'as_a_base_level_collaborator_you_dont_have_the_permission_required_to_manage_slots'
          )}
        </Title>
        <Title textColor="neutral-700" twStyle={tw`w-full mb-5`}>
          {t(isAdmin ? 'ask_your_admin_to_complete_the_purchase' : 'ask_your_admin_to_purchase_or_cancel_slots')}
        </Title>
      </div>
    </BaseModal>
  );
}

export default EmployerNoPermissionToBuySlotModal;
